import type { ReactElement } from 'react';
import { AdaLink } from '@betrybe/ada-react';
import { FooterContainer, FooterDivider, LinkCopy } from './styles';

function Footer(): ReactElement {
  return (
    <FooterContainer>
      <AdaLink href="https://betrybe.com/" target="_blank">
        <LinkCopy>A Trybe</LinkCopy>
      </AdaLink>

      <FooterDivider>.</FooterDivider>

      <AdaLink
        href="https://betrybe.com/politica-de-privacidade"
        target="_blank"
      >
        <LinkCopy>Privacidade</LinkCopy>
      </AdaLink>

      <FooterDivider>.</FooterDivider>

      <AdaLink href="https://betrybe.com/termos-de-uso" target="_blank">
        <LinkCopy>Termos de Uso</LinkCopy>
      </AdaLink>
    </FooterContainer>
  );
}

export default Footer;
